import { render, staticRenderFns } from "./security.vue?vue&type=template&id=cf151eee&"
import script from "./security.vue?vue&type=script&lang=ts&"
export * from "./security.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports